<script>
  import ListMain from '../../../../app/components/list/Main.vue'
  import ListHeader from '../../../../app/components/list/Header.vue'
  import ListEditButton from '../../../../app/components/list/EditButton.vue'
  import ListDeleteButton from '../../../../app/components/list/DeleteButton.vue'
  import RegistrationStatusLabel from './StatusLabel'
  import DataService from '../../../services/dataService'
  import dateMixin from '../../../../mixins/helper'
  import bus from '@utils/bus'
  import {isEmpty} from 'lodash'
  import {mapGetters} from 'vuex'

  export default {
    components: {ListMain, ListHeader, ListEditButton, ListDeleteButton, RegistrationStatusLabel},
    mixins: [dateMixin],
    data () {
      return {
        isLoadingData: true,
        filters: {ref_pessoa: '', status_id: '', dates: [], modality_id: ''},
        dependencies: {}
      }
    },
    mounted () {
      this.getDependencies()
      bus.$emit('list-init', {
        domain: 'registration',
        relations: ['main_event', 'status', 'person', 'modalities.event_modality.modality']
      }, () => {
        this.isLoadingData = false
      })
    },
    computed: {
      ...mapGetters(['listStore'])
    },
    methods: {
      getDependencies () {
        DataService.get([{domain: 'status'}, {domain: 'modality'}]).then((result) => {
          this.dependencies = result
        })
      },
      onFilter () {
        const searchData = {}
        if (this.filters.status_id) {
          searchData.status_id = this.filters.status_id
        }
        if (!isEmpty(this.filters.ref_pessoa)) {
          searchData.person = {
            has: [
              {
                ref_pessoa: {
                  ilike: '%' + this.filters.ref_pessoa + '%'
                }
              }
            ]
          }
        }
        if (this.filters.modality_id) {
          searchData.modalities = {
            has: [
              {
                event_modality: {
                  has: [
                    {
                      modality_id: this.filters.modality_id
                    }
                  ]
                }
              }
            ]
          }
        }
        let startDate = this.dateFormat(this.filters.dates[0], 'en')
        let endDate = this.dateFormat(this.filters.dates[1], 'en')
        if (startDate.length > 0 && endDate.length > 0) {
          searchData.created_at = {
            between: [startDate + ' 00:00:00', endDate + ' 23:59:59']
          }
        } else if (startDate.length > 0 && endDate.length === 0) {
          searchData.created_at = {
            between: [startDate, startDate]
          }
        } else if (startDate.length === 0 && endDate.length > 0) {
          searchData.created_at = {
            between: [endDate, endDate]
          }
        }
        bus.$emit('list-filter', this.filters, searchData)
      },
      onFilterClean () {
        this.filters = {ref_pessoa: '', status_id: '', dates: [], modality_id: ''}
        bus.$emit('list-filter-clean', this.filters)
      },
      onDestroy (item) {
        bus.$emit('list-destroy-item', item)
      }
    },
    beforeMount () {
      this.listStore.listData = []
    }
  }
</script>

<template>
    <div>

        <ListHeader title="Inscrições"/>

        <ListMain>

            <div slot="filters" v-if="true">

                <el-card class="el-card__search_list box-card">
                    <div slot="header">
                        <span>Pesquisar</span>
                        <div>
                            <el-button type="primary" @click="onFilter">Pesquisar</el-button>
                            <el-button type="default" @click="onFilterClean">Limpar</el-button>
                        </div>
                    </div>
                    <el-form :inline="true" :model="filters" class="demo-form-inline">
                        <el-form-item label="Matrícula">
                            <el-input v-model="filters.ref_pessoa" placeholder="Filtrar por matrícula"/>
                        </el-form-item>
                        <el-form-item label="Data da Inscrição">
                            <el-date-picker
                                    v-model="filters.dates"
                                    type="daterange"
                                    format="dd/MM/yyyy"
                                    placeholder="Filtrar por data">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="Status">
                            <el-select v-model="filters.status_id"
                                       filterable
                                       placeholder="Filtrar Status"
                                       empty-text="Nenhum registro encontrado">
                                <el-option v-for="item in dependencies.status"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Modalidade">
                            <el-select v-model="filters.modality_id"
                                       filterable
                                       placeholder="Filtrar Modalidade"
                                       empty-text="Nenhum registro encontrado">
                                <el-option v-for="item in dependencies.modalities"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-card>

            </div>

            <div slot="list" v-if="!isLoadingData">

                <div class="header">
                    <h2>Lista de Inscrições</h2>
                </div>
                <table class="custom-table-list">
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Evento</th>
                        <th>Pessoa</th>
                        <th>Instituição</th>
                        <th>Data</th>
                        <th>Modalidades</th>
                        <th>Status</th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-for="item in listStore.listData">
                        <td>{{item.id}}</td>
                        <td>{{item.main_event.title}}</td>
                        <td>{{item.person.ref_pessoa}} - {{item.person.pessoa.nome}}</td>
                        <td>{{item.institution.name}}</td>
                        <td>{{item.created_at | dateTimeEnToBr}}</td>
                        <td>
                            <div v-for="modality in item.modalities">{{modality.event_modality.modality.name}}</div>
                        </td>
                        <td>
                            <div>
                                <registration-status-label :status-id="item.status_id"
                                                           :status-name="item.status.name"/>
                            </div>
                            <div class="small">Última Atualização: {{item.status_updated_at | dateTimeEnToBr }}</div>
                        </td>
                    </tr>
                    </tbody>

                </table>

            </div>

        </ListMain>
    </div>
</template>

<style lang="scss">
    .small {
        font-weight: 400;
        font-size: 11px;
        color: #555555;
    }
</style>




// WEBPACK FOOTER //
// List.vue?46d7ab1c